<template>
  <nav>
    <v-app-bar flat app>
      <v-icon class="mr-3 pointer">mdi-face-woman-shimmer</v-icon>
      <v-app-bar-title class="grey--text text-no-wrap">
        Weizhe Yuan
        <!-- <span class="font-weight-light">Weizhe</span>
        <span>Yuan</span> -->
      </v-app-bar-title>
    <v-spacer></v-spacer>
    <span class="caption">Last updated: 2023.9.11</span>
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  methods: {
  },
};
</script>

<style>

</style>
